// The sidebar shows a partner's stored logo at most 175 px wide, but some stored files are huge (one is 1.1 MB at 1,942 px) and the logo is on the screen from the first paint, so it
// competes with every data request on a slow link. Supabase can serve a stored public image resized: this returns that URL, fitted inside a 400 px box (2x for a retina screen),
// never cropped and never enlarged, so a small logo comes back pixel for pixel the same. Anything that is not a Supabase public storage URL is returned untouched.
const OBJECT = '/storage/v1/object/public/';
const RENDER = '/storage/v1/render/image/public/';

export function sizedLogoUrl(url) {
  if (typeof url !== 'string' || !url.includes(OBJECT)) return url;
  if (url.includes('?')) return url; // already carries its own parameters: leave it
  return `${url.replace(OBJECT, RENDER)}?width=400&height=400&resize=contain&quality=85`;
}
